export interface SsrBanner {
	name: string;
	height: number;
}

export class SSRBannerManager {
	readonly banners: SsrBanner[] = [];

	registerBanner({ name, height }: SsrBanner): void {
		const bannerIndex = this.banners.findIndex((_banner) => name === _banner.name);

		if (bannerIndex < 0) {
			this.banners.push({ name, height });
		}
	}

	hasOtherBanners(bannerName: string): boolean {
		return this.banners.some((banner) => banner.name !== bannerName);
	}

	getBanners(): SsrBanner[] {
		return this.banners;
	}

	clearBanners(): void {
		this.banners.length = 0;
	}
}
